import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { MatSort, MatTableDataSource, MatDialog } from '@angular/material';
import { FormControl } from '@angular/forms';
import { RouteVehicleEditComponent } from '../route-vehicle-edit/route-vehicle-edit.component';

export interface PeriodicElement {
  name: string;
}

@Component({
  selector: 'app-route-vehicle-map-table',
  templateUrl: './route-vehicle-map-table.component.html',
  styleUrls: ['./route-vehicle-map-table.component.scss']
})



export class RouteVehicleMapTableComponent implements OnInit {
  route_map_data: Object;
  routes: string[];
  // nameFilter = new FormControl('');
  // filterValues = {
  //   id: '',
  //   name: '',
  // };
  // displayedColumns: string[] = ['route_name', 'morning', 'evening'];
  // dataSource: any;
  // @ViewChild(MatSort, {static: true}) sort: MatSort;
  route_list = [];
  vehicle_map: PeriodicElement[];

  constructor(private http: HttpService, private dialog: MatDialog) {
    console.log('vehicle map');
    this.serveVehicleData()
  }
  serveVehicleData() {
    this.http.getRouteVehiclelog().subscribe((data: []) => {
      console.log(data);
      this.vehicle_map = data;
      this.route_list = Object.keys(data)
    }, (error) => {
      console.log(error);
    })
  }
  openDialog(route_id, vehicle_id): void {
    console.log('dialog open');
    console.log(route_id, vehicle_id)
    const dialogRef = this.dialog.open(RouteVehicleEditComponent, {
      height: '250px',
      width: '665px',
      data: {
        'route_id': route_id,
        'vehicle_id': vehicle_id,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      console.log(res);
      if (res) {
        this.serveVehicleData();
      }
    });
  }




  ngOnInit() {
  }


}
